import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatToFrenchDate } from '../../../../utils/dateUtils';
import Badge from '../../../../components/Common/ui/Badge';
import Datatable from '../../../../components/Common/dataTable';

interface AbsenceRecord {
  date: string;
  subject: string;
  hours: number;
  type: string;
}

interface AbsenceHistoryTableProps {
  absenceHistory: AbsenceRecord[];
}

const AbsenceHistoryTable: React.FC<AbsenceHistoryTableProps> = ({ absenceHistory }) => {
  const { t } = useTranslation();
  
  if (absenceHistory.length === 0) {
    return (
      <div className="text-center py-4">
        <i className="ti ti-calendar-check text-success ti-3x mb-3"></i>
        <p>{t('no_absence_records')}</p>
      </div>
    );
  }
  
  // Define columns for the Datatable component
  const columns = [
    {
      title: t('date'),
      dataIndex: 'date',
      key: 'date',
      render: (date: string) => {
        try {
          return formatToFrenchDate(new Date(date));
        } catch {
          return date;
        }
      }
    },
    {
      title: t('subject'),
      dataIndex: 'subject',
      key: 'subject',
    },
    {
      title: t('hours'),
      dataIndex: 'hours',
      key: 'hours',
    },
    {
      title: t('status'),
      dataIndex: 'type',
      key: 'type',
      render: (type: string) => (
        <Badge
          variant={type === 'excused' ? 'success' : 'warning'}
          text={type}
        />
      )
    }
  ];
  
  // Prepare data source with unique IDs for the Datatable component
  const dataSource = absenceHistory.map((absence, index) => ({
    ...absence,
    id: index.toString() // Adding id for rowKey in Datatable
  }));
  
  return (
    <div className="table-responsive">
      <Datatable 
        columns={columns}
        dataSource={dataSource}
        Selection={false}
        bordered={false}
        pagination={true}
      />
    </div>
  );
};

export default AbsenceHistoryTable;
